var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-2"},[_c('h2',[_vm._v("Edit Expected Transaction")]),_c('expected-transaction-form',{attrs:{"expectedTransaction":_vm.expectedTransaction},on:{"save":_vm.save,"deleteClicked":_vm.deleteClicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }